import React from 'react';
import GDPRPolicy  from '../components/helpers/GdprPolicy';

function Gdpr() {
    return <GDPRPolicy />;
};

export default Gdpr;